/* eslint-disable react/no-array-index-key */
import { useState } from "react";
import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutSimple from "../../components/withLayoutSimple/withLayoutSimple";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageFatherQuiz.module.scss";

const config = {
  suffix: "p27",
  questions: [5, 5, 4],
  correctAnswers: [5, 5, 2],
};

function PageFatherQuiz() {
  const getImgSet = useImgSet();

  const [results, setResults] = useState(() => {
    return config.questions.map(() => null);
  });

  const heading = getImgSet("quiz_heading");

  const back = getImgSet("back__p21");
  const fail = getImgSet("quiz_fail");
  const success = getImgSet("quiz_success");

  const numbers = config.questions.map((question, questionIdx) => {
    return getImgSet(`quiz_number__0${questionIdx + 1}`);
  });

  const onAnswer = (questionIdx, answerIdx) => {
    setResults((state) => {
      const res = [...state];
      res[questionIdx] = answerIdx;

      return res;
    });
  };

  const renderQuiz = config.questions.map((length, questionIdx) => {
    const question = getImgSet(
      `quiz_question__0${questionIdx + 1}__${config.suffix}`,
      "png",
      s.question
    );

    const answers = [];

    for (let answerIdx = 0; answerIdx < length; answerIdx++) {
      const answer = getImgSet(
        `quiz_answer__0${questionIdx + 1}_0${answerIdx + 1}__${config.suffix}`
      );

      answers.push(
        <div
          key={answerIdx}
          className={cn(s.answer, {
            [s.answer__choosen]: answerIdx === results[questionIdx],
          })}
          style={{ animationDelay: `${answerIdx * 100 + 1000}ms` }}
          onClick={() => onAnswer(questionIdx, answerIdx)}
        >
          {answer}
        </div>
      );
    }

    return (
      <div key={questionIdx}>
        {questionIdx === 0 && <div className={s.heading}>{heading}</div>}
        <div className={s.container_inner}>
          <div className={s.question_number}>{numbers[questionIdx]}</div>
          <div className={s.question_wrapper}>
            <div className={s.question}>{question}</div>
            {answers}
          </div>
        </div>
      </div>
    );
  });

  const renderResult = () => {
    if (results.some((res) => res === null)) return null;

    if (results.every((res, idx) => res + 1 === config.correctAnswers[idx]))
      return success;

    return fail;
  };

  return (
    <div className={s.root}>
      <div className={s.inner}>
        {renderQuiz}
        <div className={s.result}>{renderResult()}</div>
        <Link to="/" className={s.back}>
          {back}
        </Link>
      </div>
    </div>
  );
}

export default withLayoutSimple(PageFatherQuiz, true, false, false);
